/**
 * Top-level keys in GET /notify/notification_center response.
 * Each value is an array of row objects (see API docs in slice).
 */
/** Default page size for GET /notify/notification_center/:table_id */
export const NOTIFICATION_CENTER_PAGE_SIZE = 20;

/** Loaded via bulk GET /notify/notification_center (not per-table pagination). */
export const NOTIFICATION_CENTER_DEADLINES_TAB_ID = "deadlines";

export function isNotificationCenterPaginatedTable(tableId) {
  return Boolean(tableId) && tableId !== NOTIFICATION_CENTER_DEADLINES_TAB_ID;
}

export const NOTIFICATION_CENTER_TAB_KEYS = [
  "reporting",
  "messages",
  "cases",
  "charge_invoices",
  "product",
  "settings",
  "deadlines",
];
